import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { Affix } from 'antd'
import useQuery from '../../hooks/useQuery'
import styles from './index.module.scss'

export default function PageTabs() {
  const location = useLocation()
  const history = useHistory()
  const pathname = location.pathname
  const useQueryIns = useQuery()
  const tid = useQueryIns.get('tid')

  const handleNav = (navPath: string): void => {
    if (navPath === pathname) return
    history.push(`${navPath}?tid=${tid}`)
  }

  return (
    <Affix offsetTop={0}>
      <div className={styles.tabsWraps}>
        <div
          className={`${styles.tabItem} ${
            pathname === '/record' ? styles.tabItemActive : ''
          }`}
          onClick={() => handleNav('/record')}
        >
          <span className={styles.title}>售后服务登记</span>
        </div>
        <div
          className={`${styles.tabItem} ${
            pathname === '/history' ? styles.tabItemActive : ''
          }`}
          onClick={() => handleNav('/history')}
        >
          <span className={styles.title}>服务记录</span>
        </div>
      </div>
    </Affix>
  )
}
